module.exports = __webpack_public_path__ + "static/media/hemsida_intro.ce48d414.mp4";